export const QUICK_SEARCH_LOCATION_KEY = 'quickSearch';
export const QUICK_SEARCH_ROUTE_ROOT = '/orders/all-orders-search-result';

export const getLocationQuickSearchTerm = (location = {}, searchKey = QUICK_SEARCH_LOCATION_KEY) => {
  const searchParams = new URLSearchParams(location.search);
  const searchTerm = searchParams.get(searchKey) || '';
  return !!searchTerm.length && searchTerm;
};

export const copySearchTermsToPath = (location = {}, basePath) => {
  return `${basePath}${location.search || ''}`;
};

export const makeQuickSearchParam = (searchTerm) => {
  return `${QUICK_SEARCH_LOCATION_KEY}=${encodeURIComponent(searchTerm)}`;
};

export const removeQuickSearchTerm = (searchParams) => {
  const newParams = new URLSearchParams(searchParams);
  newParams.delete(QUICK_SEARCH_LOCATION_KEY);
  return newParams.toString();
};

export const pushToHistoryWithSearchTerm = (history, searchTerm, customLandingPath) => {
  if (!searchTerm || !searchTerm.length) {
    const search = removeQuickSearchTerm(history.location.search);
    return history.push({ search });
  }
  const pushOptions = { search: makeQuickSearchParam(searchTerm) };
  if (customLandingPath) {
    pushOptions.pathname = customLandingPath;
  }
  history.push(pushOptions);
};
